(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-editorial"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.cexReady === 'true') return;
      root.dataset.cexReady = 'true';

      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-cex-row]'));
      var visuals = Array.prototype.slice.call(root.querySelectorAll('[data-cex-visual]'));
      var fallback = root.querySelector('[data-cex-visual=\"default\"]');
      var idle = null;

      function show(key) {
        var found = false;
        visuals.forEach(function (img) {
          var on = img.dataset.cexVisual === key;
          img.classList.toggle('is-active', on);
          if (on) found = true;
        });
        if (!found && fallback) fallback.classList.add('is-active');
      }

      function desktop() {
        return window.matchMedia('(min-width: 990px)').matches;
      }

      rows.forEach(function (row) {
        var key = row.dataset.cexRow;
        var activate = function () {
          if (!desktop()) return;
          window.clearTimeout(idle);
          root.dataset.hovering = 'true';
          rows.forEach(function (r) { r.classList.toggle('is-active', r === row); });
          show(key);
        };
        row.addEventListener('mouseenter', activate);
        row.addEventListener('focus', activate);
      });

      var list = root.querySelector('.cex__list');
      if (list) {
        list.addEventListener('mouseleave', function () {
          if (!desktop()) return;
          idle = window.setTimeout(function () {
            rows.forEach(function (r) { r.classList.remove('is-active'); });
            root.dataset.hovering = 'false';
            show(fallback ? 'default' : '0');
          }, 160);
        });
      }

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-cex-item]'));

      if (!reduce && 'IntersectionObserver' in window && root.classList.contains('cex--reveal')) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
        items.forEach(function (el) { io.observe(el); });
      } else {
        items.forEach(function (el) { el.classList.add('is-in'); });
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-cex]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-premium"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.cpxReady === 'true') return;
      root.dataset.cpxReady = 'true';

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-cpx-item]'));

      if (!reduce && 'IntersectionObserver' in window && root.classList.contains('cpx--reveal')) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
        items.forEach(function (el) { io.observe(el); });
      } else {
        items.forEach(function (el) { el.classList.add('is-in'); });
      }

      var track = root.querySelector('[data-cpx-track]');
      var bar = root.querySelector('[data-cpx-bar]');

      if (track && bar) {
        var update = function () {
          var max = track.scrollWidth - track.clientWidth;
          if (max <= 0) {
            bar.style.width = '100%';
            bar.style.transform = 'none';
            return;
          }
          var ratio = track.scrollLeft / max;
          var visible = track.clientWidth / track.scrollWidth;
          var widthPct = Math.max(visible * 100, 12);
          bar.style.width = widthPct + '%';
          bar.style.transform = 'translateX(' + ratio * (100 / (widthPct / 100) - 100) + '%)';
        };
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-cpx]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-premium"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.fpxReady === 'true') return;
      root.dataset.fpxReady = 'true';

      root.querySelectorAll('[data-fpx-toggle]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (window.matchMedia('(min-width: 750px)').matches) return;
          var col = button.closest('[data-fpx-col]');
          if (!col) return;
          var open = col.dataset.open === 'true';
          col.dataset.open = open ? 'false' : 'true';
          button.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-fpx]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-brand"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.hdbReady === 'true') return;
      root.dataset.hdbReady = 'true';

      var scrim = root.querySelector('[data-hdb-scrim]');

      function setScrim(on) {
        if (!scrim) return;
        if (on) {
          scrim.hidden = false;
          window.requestAnimationFrame(function () { root.dataset.scrim = 'true'; });
        } else {
          root.dataset.scrim = 'false';
          window.setTimeout(function () {
            if (root.dataset.scrim !== 'true') scrim.hidden = true;
          }, 260);
        }
      }

      var notesWrap = root.querySelector('[data-hdb-notes]');
      if (notesWrap) {
        var notes = Array.prototype.slice.call(notesWrap.querySelectorAll('[data-hdb-note]'));
        if (notes.length > 1) {
          var current = 0;
          var delay = parseInt(notesWrap.dataset.interval, 10) || 5;
          window.setInterval(function () {
            notes[current].classList.remove('is-active');
            current = (current + 1) % notes.length;
            notes[current].classList.add('is-active');
          }, delay * 1000);
        }
      }

      var searchWrap = root.querySelector('[data-hdb-search]');
      var searchInput = root.querySelector('[data-hdb-search-input]');
      var searchResults = root.querySelector('[data-hdb-search-results]');
      var searchTimer = null;

      function openSearch() {
        if (!searchWrap) return;
        searchWrap.hidden = false;
        setScrim(true);
        if (searchInput) window.setTimeout(function () { searchInput.focus(); }, 40);
      }

      function closeSearch() {
        if (!searchWrap) return;
        searchWrap.hidden = true;
        setScrim(false);
      }

      function formatMoney(cents) {
        var value = Number(cents);
        if (!isFinite(value)) return '';
        try {
          return new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: root.dataset.currency || 'USD',
            maximumFractionDigits: 0
          }).format(value / 100);
        } catch (e) {
          return String(value / 100);
        }
      }

      function renderResults(items) {
        if (!searchResults) return;
        if (!items.length) {
          searchResults.innerHTML = '<p class=\"hdb__search-empty\">Sin resultados.</p>';
          return;
        }
        searchResults.innerHTML = items.map(function (item) {
          var img = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
          return '<a class=\"hdb__result\" href=\"' + item.url + '\">' +
            '<span class=\"hdb__result-media\">' + (img ? '<img src=\"' + img + '\" alt=\"\" loading=\"lazy\">' : '') + '</span>' +
            '<span class=\"hdb__result-title\">' + item.title + '</span>' +
            '<span class=\"hdb__result-price\">' + formatMoney(item.price) + '</span>' +
            '</a>';
        }).join('');
      }

      function runSearch(term) {
        if (!searchResults) return;
        if (term.length < 2) { searchResults.innerHTML = ''; return; }
        var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
          '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';
        fetch(url)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            renderResults(products);
          })
          .catch(function () {});
      }

      root.querySelectorAll('[data-hdb-search-open]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (searchWrap && !searchWrap.hidden) closeSearch(); else openSearch();
        });
      });
      root.querySelectorAll('[data-hdb-search-close]').forEach(function (b) {
        b.addEventListener('click', closeSearch);
      });

      if (searchInput) {
        searchInput.addEventListener('input', function () {
          window.clearTimeout(searchTimer);
          var term = searchInput.value.trim();
          searchTimer = window.setTimeout(function () { runSearch(term); }, 250);
        });
      }

      var drawer = root.querySelector('[data-hdb-drawer]');
      var levels = Array.prototype.slice.call(root.querySelectorAll('[data-hdb-level]'));
      var backBtn = root.querySelector('[data-hdb-drawer-back]');

      function showLevel(name) {
        levels.forEach(function (level) {
          var active = level.dataset.hdbLevel === name;
          level.classList.toggle('is-active', active);
          level.classList.toggle('is-left', !active && level.dataset.hdbLevel === 'root' && name !== 'root');
        });
        if (backBtn) backBtn.hidden = name === 'root';
      }

      function openDrawer() {
        if (!drawer) return;
        drawer.hidden = false;
        showLevel('root');
        window.requestAnimationFrame(function () { root.dataset.drawer = 'true'; });
        document.body.style.overflow = 'hidden';
      }

      function closeDrawer() {
        if (!drawer) return;
        root.dataset.drawer = 'false';
        document.body.style.overflow = '';
        window.setTimeout(function () {
          if (root.dataset.drawer !== 'true') drawer.hidden = true;
        }, 320);
      }

      root.querySelectorAll('[data-hdb-drawer-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
      root.querySelectorAll('[data-hdb-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
      if (backBtn) backBtn.addEventListener('click', function () { showLevel('root'); });
      root.querySelectorAll('[data-hdb-drawer-to]').forEach(function (b) {
        b.addEventListener('click', function () { showLevel(b.dataset.hdbDrawerTo); });
      });

      if (drawer) {
        drawer.addEventListener('click', function (event) {
          if (event.target === drawer) closeDrawer();
        });
      }

      if (scrim) scrim.addEventListener('click', closeSearch);

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        closeSearch(); closeDrawer();
      });

      var countEl = root.querySelector('[data-hdb-cart-count]');

      function refreshCart() {
        if (!countEl) return;
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            countEl.textContent = cart.item_count;
            countEl.classList.toggle('is-empty', cart.item_count === 0);
          })
          .catch(function () {});
      }

      ['cart:updated', 'cart:refresh', 'cart:change', 'cart:added'].forEach(function (name) {
        document.addEventListener(name, refreshCart);
      });
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) refreshCart();
      });
      window.addEventListener('pageshow', function (event) {
        if (event.persisted) refreshCart();
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-hdb]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-menu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.mmnReady === 'true') return;
      root.dataset.mmnReady = 'true';

      var trigger = root.querySelector('[data-mmn-trigger]');
      var panel = root.querySelector('[data-mmn-panel]');
      var railLinks = Array.prototype.slice.call(root.querySelectorAll('[data-mmn-cat]'));
      var catPanels = Array.prototype.slice.call(root.querySelectorAll('[data-mmn-catpanel]'));
      var closeTimer = null;

      function desktop() {
        return window.matchMedia('(min-width: 990px)').matches;
      }

      function open() {
        if (!panel || !desktop()) return;
        window.clearTimeout(closeTimer);
        panel.hidden = false;
        root.dataset.open = 'true';
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      }

      function close() {
        if (!panel) return;
        root.dataset.open = 'false';
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        closeTimer = window.setTimeout(function () {
          if (root.dataset.open !== 'true' && desktop()) panel.hidden = true;
        }, 240);
      }

      function activate(index) {
        railLinks.forEach(function (link) {
          link.classList.toggle('is-active', link.dataset.mmnCat === index);
        });
        catPanels.forEach(function (cat) {
          cat.classList.toggle('is-active', cat.dataset.mmnCatpanel === index);
        });
      }

      if (trigger) {
        trigger.addEventListener('click', function () {
          if (root.dataset.open === 'true') {
            close();
          } else {
            open();
          }
        });
        trigger.addEventListener('mouseenter', open);
        trigger.addEventListener('focus', open);
      }

      root.addEventListener('mouseleave', close);
      if (panel) panel.addEventListener('mouseenter', open);

      railLinks.forEach(function (link) {
        link.addEventListener('mouseenter', function () {
          if (desktop()) activate(link.dataset.mmnCat);
        });
        link.addEventListener('focus', function () {
          if (desktop()) activate(link.dataset.mmnCat);
        });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') close();
      });

      document.addEventListener('click', function (event) {
        if (!root.contains(event.target)) close();
      });

      if (panel && desktop()) panel.hidden = true;
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-mmn]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mpm-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.mabReady === 'true') return;
      root.dataset.mabReady = 'true';

      var notes = Array.prototype.slice.call(root.querySelectorAll('[data-mab-note]'));
      if (notes.length < 2) return;

      var i = 0;
      var timer = null;
      var delay = (parseInt(root.dataset.interval, 10) || 5) * 1000;

      function show(n) {
        i = (n + notes.length) % notes.length;
        notes.forEach(function (el, idx) {
          el.classList.toggle('is-on', idx === i);
        });
      }

      function start() {
        stop();
        timer = window.setInterval(function () { show(i + 1); }, delay);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      var prev = root.querySelector('[data-mab-prev]');
      var next = root.querySelector('[data-mab-next]');
      if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
      if (next) next.addEventListener('click', function () { show(i + 1); start(); });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else { start(); }
      });

      start();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-mab]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mpm-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.mctReady === 'true') return;
      root.dataset.mctReady = 'true';
      var items = root.querySelectorAll('[data-mct-rev]');
      if (!items.length) return;
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, idx) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          window.setTimeout(function () { el.classList.add('is-in'); }, idx * 90);
          io.unobserve(el);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      items.forEach(function (el) { io.observe(el); });
    }
    function initAll(scope) {
      (scope || document).querySelectorAll('[data-mct]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mpm-header-pro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.mhdReady === 'true') return;
      root.dataset.mhdReady = 'true';

      var items = root.querySelectorAll('.mhd__item');
      var panels = root.querySelectorAll('.mhd__panel');
      var openTimer = null, closeTimer = null, current = null;

      function show(idx) {
        window.clearTimeout(closeTimer);
        if (current === idx) return;
        current = idx;
        items.forEach(function (li) { li.classList.toggle('is-on', li.dataset.idx === idx); });
        panels.forEach(function (p) { p.classList.toggle('is-on', p.dataset.panel === idx); });
      }
      function hide() {
        current = null;
        items.forEach(function (li) { li.classList.remove('is-on'); });
        panels.forEach(function (p) { p.classList.remove('is-on'); });
      }
      function scheduleHide() {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(hide, 160);
      }

      items.forEach(function (li) {
        li.addEventListener('mouseenter', function () {
          window.clearTimeout(openTimer);
          openTimer = window.setTimeout(function () { show(li.dataset.idx); }, 90);
        });
        li.addEventListener('mouseleave', function () { window.clearTimeout(openTimer); scheduleHide(); });
        var a = li.querySelector('.mhd__link');
        if (a) a.addEventListener('focus', function () { show(li.dataset.idx); });
      });
      panels.forEach(function (p) {
        p.addEventListener('mouseenter', function () { window.clearTimeout(closeTimer); });
        p.addEventListener('mouseleave', scheduleHide);
      });
      root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) hide(); });

      var searchBtn = root.querySelector('[data-mhd-search]');
      if (searchBtn) {
        searchBtn.addEventListener('click', function () {
          root.classList.toggle('is-searching');
          if (root.classList.contains('is-searching')) {
            var input = root.querySelector('[data-mhd-input]');
            if (input) window.setTimeout(function () { input.focus(); }, 60);
          }
        });
      }

      var drawer = document.querySelector('[data-mhd-drawer]');
      var burger = root.querySelector('[data-mhd-menu]');

      function openDrawer() {
        if (!drawer) return;
        drawer.classList.add('is-open');
        document.body.classList.add('mhd-locked');
        requestAnimationFrame(function () { drawer.classList.add('is-in'); });
        drawer.setAttribute('aria-hidden', 'false');
      }
      function closeDrawer() {
        if (!drawer) return;
        drawer.classList.remove('is-in');
        drawer.setAttribute('aria-hidden', 'true');
        window.setTimeout(function () {
          drawer.classList.remove('is-open');
          document.body.classList.remove('mhd-locked');
        }, 380);
      }

      if (burger) burger.addEventListener('click', openDrawer);
      if (drawer) {
        drawer.addEventListener('click', function (e) {
          if (e.target.closest('[data-mhd-drawer-close]')) { closeDrawer(); return; }
          var acc = e.target.closest('[data-mhd-acc]');
          if (acc) {
            var g = acc.closest('.mhd-drawer__group');
            if (g) g.classList.toggle('is-open');
          }
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        hide();
        root.classList.remove('is-searching');
        closeDrawer();
      });
    }

    function initAll(scope) { (scope || document).querySelectorAll('[data-mhd]').forEach(init); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mpm-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.heroReady === 'true') return;
      root.dataset.heroReady = 'true';
      var cue = root.querySelector('[data-mpm-cue]');
      if (!cue) return;
      cue.addEventListener('click', function () {
        var sec = root.closest('.shopify-section');
        var next = sec ? sec.nextElementSibling : null;
        if (next) {
          next.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollBy({ top: window.innerHeight * 0.8, behavior: 'smooth' });
        }
      });
    }
    function initAll(scope) {
      (scope || document).querySelectorAll('[data-mpm-hero]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mpm-mega"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.megReady === 'true') return;
      root.dataset.megReady = 'true';

      var items = root.querySelectorAll('.mmeg__item');
      var panels = root.querySelectorAll('.mmeg__panel');
      var openTimer = null;
      var closeTimer = null;
      var current = null;

      function show(idx) {
        window.clearTimeout(closeTimer);
        if (current === idx) return;
        current = idx;
        items.forEach(function (li) { li.classList.toggle('is-on', li.dataset.idx === idx); });
        panels.forEach(function (p) { p.classList.toggle('is-on', p.dataset.panel === idx); });
      }

      function hide() {
        current = null;
        items.forEach(function (li) { li.classList.remove('is-on'); });
        panels.forEach(function (p) { p.classList.remove('is-on'); });
      }

      function scheduleHide() {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(hide, 160);
      }

      items.forEach(function (li) {
        li.addEventListener('mouseenter', function () {
          window.clearTimeout(openTimer);
          openTimer = window.setTimeout(function () { show(li.dataset.idx); }, 90);
        });
        li.addEventListener('mouseleave', function () {
          window.clearTimeout(openTimer);
          scheduleHide();
        });
        var link = li.querySelector('[data-trigger]');
        if (link) {
          link.addEventListener('focus', function () { show(li.dataset.idx); });
        }
      });

      panels.forEach(function (p) {
        p.addEventListener('mouseenter', function () { window.clearTimeout(closeTimer); });
        p.addEventListener('mouseleave', scheduleHide);
      });

      root.addEventListener('focusout', function (e) {
        if (!root.contains(e.relatedTarget)) hide();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') hide();
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-mmeg]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mpm-rating"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function place() {
      var host = document.querySelector('[data-mpm-rating]');
      if (!host) return;
      var main = document.getElementById('MainContent');
      if (!main) return;

      var widget = host.firstElementChild;
      if (!widget) return;
      if (document.querySelector('.mrt--placed')) return;

      var link = main.querySelector('[ref="productTitleLink"]');
      var anchor = null;

      if (link) {
        anchor = link.closest('.product-title') || link.parentElement;
      } else {
        var h1 = main.querySelector('h1');
        if (h1) anchor = h1.closest('[class]') || h1;
      }

      if (!anchor || !anchor.parentElement) return;

      widget.classList.add('mrt--placed');
      anchor.parentElement.insertBefore(widget, anchor.nextSibling);
      host.remove();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', place);
    } else {
      place();
    }
    document.addEventListener('shopify:section:load', place);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mpm-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function load(root) {
      if (!root || root.dataset.mrcDone === 'true') return;
      root.dataset.mrcDone = 'true';
      var url = root.dataset.url;
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-mrc]');
          if (fresh) {
            root.innerHTML = fresh.innerHTML;
            root.querySelectorAll('.mcd').forEach(function (c) { c.classList.add('is-in'); });
          }
        })
        .catch(function () {});
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-mrc]').forEach(load);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mpm-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.mtesReady === 'true') return;
      root.dataset.mtesReady = 'true';
      var items = root.querySelectorAll('[data-mtes-rev]');
      if (!items.length) return;
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, idx) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          window.setTimeout(function () { el.classList.add('is-in'); }, idx * 100);
          io.unobserve(el);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      items.forEach(function (el) { io.observe(el); });
    }
    function initAll(scope) {
      (scope || document).querySelectorAll('[data-mtes]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mpm-whatsapp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.mwaReady === 'true') return;
      root.dataset.mwaReady = 'true';

      var KEY = 'mpm-wa-tip-dismissed';

      var btn = root.querySelector('[data-mwa-btn]');
      if (btn) {
        btn.addEventListener('click', function () {
          try { window.sessionStorage.setItem(KEY, '1'); } catch (e) {}
        });
      }

      var tip = root.querySelector('[data-mwa-tip]');
      if (!tip) return;

      var dismissed = false;
      try { dismissed = window.sessionStorage.getItem(KEY) === '1'; } catch (e) {}
      if (dismissed) return;

      var delay = (parseFloat(root.dataset.delay) || 4) * 1000;

      window.setTimeout(function () {
        tip.hidden = false;
        requestAnimationFrame(function () { tip.classList.add('is-in'); });
      }, delay);

      var closeBtn = root.querySelector('[data-mwa-tipclose]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          tip.classList.remove('is-in');
          window.setTimeout(function () { tip.hidden = true; }, 350);
          try { window.sessionStorage.setItem(KEY, '1'); } catch (e) {}
        });
      }
    }

    function initAll(scope) { (scope || document).querySelectorAll('[data-mwa]').forEach(init); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-premium"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.ppxReady === 'true') return;
      root.dataset.ppxReady = 'true';

      var track = root.querySelector('[data-ppx-track]');
      var prev = root.querySelector('[data-ppx-prev]');
      var next = root.querySelector('[data-ppx-next]');
      if (!track || !prev || !next) return;

      function step() {
        var card = track.querySelector('.mcd');
        return card ? card.offsetWidth + 16 : 320;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      function sync() {
        var max = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      }

      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-ppx]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-shorts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (!root || root.dataset.vshortsReady === 'true') return;
      root.dataset.vshortsReady = 'true';

      var autoplay = root.dataset.autoplay === 'true';
      var videos = Array.prototype.slice.call(root.querySelectorAll('[data-vshorts-video]'));
      if (!videos.length) return;

      function safePlay(video) {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }

      videos.forEach(function (video) {
        video.muted = true;
        video.setAttribute('muted', '');
        video.playsInline = true;
      });

      if (autoplay && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              safePlay(entry.target);
            } else {
              entry.target.pause();
            }
          });
        }, { threshold: 0.25 });
        videos.forEach(function (video) {
          observer.observe(video);
        });
      } else if (!autoplay) {
        videos.forEach(function (video) {
          video.removeAttribute('autoplay');
          video.setAttribute('controls', 'controls');
        });
      }

      videos.forEach(function (video) {
        video.addEventListener('click', function () {
          if (video.paused) {
            safePlay(video);
          } else {
            video.pause();
          }
        });
      });

      root.querySelectorAll('[data-vshorts-sound]').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var media = button.closest('.vshorts__media');
          var video = media && media.querySelector('[data-vshorts-video]');
          if (!video) return;

          if (video.muted) {
            videos.forEach(function (other) {
              if (other !== video) {
                other.muted = true;
                var otherMedia = other.closest('.vshorts__media');
                if (otherMedia) otherMedia.dataset.unmuted = 'false';
              }
            });
          }

          video.muted = !video.muted;
          media.dataset.unmuted = video.muted ? 'false' : 'true';
          if (!video.muted && video.paused) safePlay(video);
        });
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-vshorts]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
